import React from 'react';
import './styles/bodyStyle.css';

export default function Body({ data }) {
  return (
    <div className="body-container">
      <p className="body-content">{data.content}</p>
    </div>
  )
}

